import React, { SVGProps } from 'react';

function SidebarActive(props: SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;

  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 3.2475V20.7475M16.5 3.2475H17.5M16.5 3.2475H4.5C3.80964 3.2475 3.25 3.80714 3.25 4.4975V19.4975C3.25 20.1879 3.80964 20.7475 4.5 20.7475H16.5M16.5 20.7475H17.5M17.5 3.2475V20.7475M17.5 3.2475H18.5M17.5 20.7475H18.5M18.5 3.2475V20.7475M18.5 3.2475H19.3164M18.5 20.7475H19.3164M19.3164 3.2475H19.5C19.6778 3.2475 19.8469 3.28461 20 3.35151M19.3164 3.2475V20.7475M19.3164 20.7475H19.5C19.6778 20.7475 19.8469 20.7104 20 20.6435M20 3.35151C20.4415 3.5444 20.75 3.98492 20.75 4.4975V19.4975C20.75 20.0101 20.4415 20.4506 20 20.6435M20 3.35151V20.6435"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

export default SidebarActive;
